module.exports = __webpack_public_path__ + "static/poster1-c4cc684834a12779f7ab43be6d5a9c3c.jpg";